
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { FinancialBudget, ApiGateway, PageOptions } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class FinancialBudgetEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    financialBudget: FinancialBudget;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getFinancialBudget()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getFinancialBudget(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.financialBudget = data;
                this.onDataChanged.next(this.financialBudget);
                resolve(this.financialBudget);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('financialBudget/' + this.routeParams.id).subscribe({next:(res: FinancialBudget ) => {
                    this.financialBudget = res;
                    this.onDataChanged.next(this.financialBudget);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(financialBudget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('financialBudget/', financialBudget).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(financialBudget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('financialBudget/', financialBudget).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(financialBudget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('financialBudget/' + financialBudget.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): FinancialBudget {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
